//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscList(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4.5 8C5.32843 8 6 7.32843 6 6.5C6 5.67157 5.32843 5 4.5 5C3.67157 5 3 5.67157 3 6.5C3 7.32843 3.67157 8 4.5 8Z" fill="currentColor" /><path d="M4.5 13.5C5.32843 13.5 6 12.8284 6 12C6 11.1716 5.32843 10.5 4.5 10.5C3.67157 10.5 3 11.1716 3 12C3 12.8284 3.67157 13.5 4.5 13.5Z" fill="currentColor" /><path d="M4.5 19C5.32843 19 6 18.3284 6 17.5C6 16.6716 5.32843 16 4.5 16C3.67157 16 3 16.6716 3 17.5C3 18.3284 3.67157 19 4.5 19Z" fill="currentColor" /><path d="M21 5.5H8V7.5H21V5.5Z" fill="currentColor" /><path d="M21 11H8V13H21V11Z" fill="currentColor" /><path d="M21 16.5H8V18.5H21V16.5Z" fill="currentColor" /></svg>;
}
export default IconMiscList;